import { isNil, isEmpty, anyPass, eqBy } from 'ramda';
export var isNilOrEmpty = anyPass([isNil, isEmpty]);
export var prefixValue = function (testValue, prefix) {
    return isNilOrEmpty(testValue) || testValue === false ? '' : prefix + testValue;
};
export var defaultValue = function (value, defaultVal) { return (isNilOrEmpty(value) ? defaultVal || '' : value); };
export var normalizeUrlPart = function (path) {
    return '/' +
        (path
            ? path
                .split('/')
                .filter(function (p) { return !!p; })
                .join('/')
            : '');
};
export var eqUrlParts = eqBy(normalizeUrlPart);
export var isValidPath = /^(\/[A-Za-z_?!%-]+)+\/?/i;
//# sourceMappingURL=_.utils.js.map